// Packages

// Components
import { Theme } from "./Theme/Theme";
import { FontSize } from "./FontSize/FontSize";

// Logic

// Context

// Services

// Styles

// Assets

export const Appearance = () => {
	return (
		<div className='settings-subpage'>
			<Theme />
			<FontSize />
		</div>
	);
};
